import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const TheresAPlateForEveryonePage = () => {
  const { find, meta } = usePageContent('theres-a-plate-for-everyone');
  const seo = meta?.seo;
  useTitle(seo?.title || "There's a plate for everyone");
  useMeta(seo);
  const c = find('richText') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className="page-header__content">
          <h1 className="page-header__title">{c.pageTitle || "There's a plate for everyone"}</h1>
        </div>
      </div>
      <div className="content-holder">
        <div
          className={`rich-text ${styles.wrapper}`}
          dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }}
        />
      </div>
    </div>
  );
};

export default TheresAPlateForEveryonePage;
